import React from 'react';
import { Alert as AlertComponent, AlertProps } from '@raisin/components-lib';
import * as S from './styles';

export const Alert: React.FC<AlertProps> = (props) => (
  <S.AlertWrapper data-testId="alert-wrapper">
    <AlertComponent mode={props.mode} testId="alert-component">
      {props.children}
    </AlertComponent>
  </S.AlertWrapper>
);
